<template>
    <div class="centerContainer">
        <h1>ChatRoom with {{ role == 'elder' ? volun.username : matched.username }}</h1>
        <div class="chatList">
            <div v-for="(message, index) in messages" :key="index" class="message"
                :class="{ 'from-me': message.senderId == uid }">
                <a-avatar :src="message.senderId == uid ? user.avatar : volun.avatar" />
                <a-tooltip :title="format(message.timestamp)">
                    <div class="message-text">{{ message.text }}</div>
                </a-tooltip>
            </div>
        </div>
        <div class="inputContainer">
            <a-textarea v-model="value" placeholder="Controlled autosize" :auto-size="{ minRows: 1, maxRows: 5 }" />
            <a-button type="primary" @click="send">Send</a-button>
        </div>
    </div>
</template>

<script>
import { addMessage, loadMessage } from '../../api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
    data() {
        return {
            value: "",
            messages: [],
            receiver: "",
            matched: undefined,
        }
    },
    computed: {
        ...mapGetters({
            user: "user/userInfo",
            role: "user/role",
            uid: "user/uid",
            volun: "user/matched",
            elderList: "user/matchedElder"
        })
    },
    mounted() {
        
        this.receiver = this.$route.params.id
        if (this.elderList) {
            this.matched = this.elderList.find(item => item.uid == this.receiver)
        }

        if (this.role == "elder") {
            loadMessage(`${this.uid}_${this.receiver}`, this.setMessage)
        } else {
            loadMessage(`${this.receiver}_${this.uid}`, this.setMessage)
        }
    },
    methods: {
        setMessage(val) {
            this.messages = val
        },
        format(val) {
            return dayjs(val).format("MMM-DD HH:mm")
        },
        send() {
            if (this.role == "elder") {
                addMessage(`${this.uid}_${this.receiver}`, this.uid, this.receiver, this.value)
                this.value = ""
            } else {
                addMessage(`${this.receiver}_${this.uid}`, this.uid, this.receiver, this.value)
                this.value = ""
            }
        }
    }
}
</script>

<style lang="less">
.centerContainer {
    padding: 0vw 3vw;

    .chatList {
        height: 80vh;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;

        .message {
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            width: 100%;


            .message-text {
                font-size: 18px;
                white-space: pre-wrap;
                padding: 5px;
                border-radius: 10px;
                margin: 0px 10px;
            }
        }

        .from-me {
            flex-direction: row-reverse;

            color: white;

            .message-text {
                background-color: #2196F3;
            }
        }


    }

    .inputContainer {
        display: flex;
        flex-direction: row;
    }
}
</style>